module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Icono-1.c4670e23.svg";